export const ACROSS = "across";
export const DOWN = "down";
export const BLANK_BOX_CHAR = ".";
